module.exports = __webpack_public_path__ + "img/keyboard_ModeArea.5bd2869c.png";